import React from 'react';

const colors = {
  ok: 'var(--status-ok)',
  warn: 'var(--status-warn)',
  error: 'var(--status-error)',
  off: 'var(--status-off)',
};

export default function StatusDot({ status = 'off', label, size = 8 }) {
  const color = colors[status] || colors.off;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <span
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          background: color,
          boxShadow: status === 'ok' ? `0 0 6px ${color}` : 'none',
          flexShrink: 0,
        }}
      />
      {label && (
        <span style={{ fontSize: 'var(--font-size-xs)', color: 'var(--text-secondary)' }}>
          {label}
        </span>
      )}
    </span>
  );
}
